export enum CampaignStep {
  details = "detail",
  select_brands = "brands",
  write_email = "email",
  review = "review",
}

export const CampaignStepOrders = [
  CampaignStep.details,
  CampaignStep.select_brands,
  CampaignStep.write_email,
  CampaignStep.review,
];

export const CampaignStepTitles: Record<CampaignStep, string> = {
  [CampaignStep.details]: "Details",
  [CampaignStep.select_brands]: "Select Brands",
  [CampaignStep.write_email]: "Write Emails",
  [CampaignStep.review]: "Review & Launch",
};

export const getActiveStep = (route: string) => {
  const step = CampaignStepOrders.findIndex((s) =>
    route?.includes(s.toLowerCase()),
  );
  return step !== -1 ? step : 0;
};

export const CAMPAIGN_BUILDER_BASE_PATH = "/dashboard/campaigns";
